import { render } from "./GameBoard.vue?vue&type=template&id=632647ba&ts=true"
import script from "./GameBoard.vue?vue&type=script&lang=ts"
export * from "./GameBoard.vue?vue&type=script&lang=ts"

import "./GameBoard.vue?vue&type=style&index=0&id=632647ba&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__